import { render, staticRenderFns } from "./JdsMoney.vue?vue&type=template&id=78132222&scoped=true&"
import script from "./JdsMoney.vue?vue&type=script&lang=ts&"
export * from "./JdsMoney.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78132222",
  null
  
)

export default component.exports